const config = {
  apiUrl: 'https://api.inspiringquote.org/'
  // apiUrl: 'http://localhost:2000/'
};

export default config;
